import AttachmentActionsContainer from './AttachmentActionsContainer';
import AttachmentInfoView from './AttachmentInfoView';
import { observer } from 'mobx-react-lite';
import { AttachmentFullViewState } from 'owa-attachment-full-data';
import { AttachmentModel } from 'owa-attachment-model-store';
import { AttachmentPreviewMode } from 'owa-sxs-store';
import * as React from 'react';

export interface AttachmentImageInfoProps {
    attachment: AttachmentModel;
    attachmentViewState: AttachmentFullViewState;
    onDeleteButtonClicked: (attachmentViewState: AttachmentFullViewState) => void;
    isActionsContainerVisible: boolean;
}

const styles = require('./AttachmentImageView.scss');
const classNames = require('classnames/bind').bind(styles);

const AttachmentImageInfoView = observer(function AttachmentImageInfoView(
    props: AttachmentImageInfoProps
) {
    const conditionalStyles = {
        infoContainerForReadingPane: props.attachmentViewState.isReadOnly,
    };
    return props.attachmentViewState.shouldShowImageOverlay ? (
        <div className={classNames(styles.infoContainer, conditionalStyles)}>
            <AttachmentInfoView
                attachmentViewState={props.attachmentViewState}
                attachment={props.attachment}
                isForImageView={true}
                isActionsContainerVisible={props.isActionsContainerVisible}
                previewState={AttachmentPreviewMode.None}
            />
            {props.isActionsContainerVisible && (
                <AttachmentActionsContainer
                    attachmentViewState={props.attachmentViewState}
                    onDeleteButtonClicked={props.onDeleteButtonClicked}
                    isForImageView={true}
                    previewState={AttachmentPreviewMode.None}
                    attachmentClass={props.attachment.attachmentClass}
                />
            )}
        </div>
    ) : null;
});
export default AttachmentImageInfoView;
